/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolRouteIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-route"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M9 21.32Q9 21.32 8.1 21.32Q7.2 21.32 5.94 20.06Q4.67 18.8 4.67 17L4.67 9.05Q3.8 8.65 3.24 7.84Q2.67 7.03 2.67 6Q2.67 4.63 3.65 3.65Q4.63 2.67 6 2.67Q7.38 2.67 8.35 3.65Q9.32 4.63 9.32 6Q9.32 7.03 8.76 7.84Q8.2 8.65 7.33 9.05L7.33 17Q7.33 17.7 7.81 18.19Q8.3 18.68 9 18.68Q9.7 18.68 10.19 18.19Q10.68 17.7 10.68 17L10.68 7Q10.68 5.2 11.94 3.94Q13.2 2.67 15 2.67Q16.8 2.67 18.06 3.94Q19.32 5.2 19.32 7L19.32 14.95Q20.2 15.35 20.76 16.16Q21.32 16.98 21.32 18Q21.32 19.38 20.35 20.35Q19.38 21.32 18 21.32Q16.63 21.32 15.65 20.35Q14.68 19.38 14.68 18Q14.68 16.98 15.24 16.15Q15.8 15.32 16.68 14.95L16.68 7Q16.68 6.3 16.19 5.81Q15.7 5.33 15 5.33Q14.3 5.33 13.81 5.81Q13.32 6.3 13.32 7L13.32 17Q13.32 18.8 12.06 20.06Q10.8 21.32 9 21.32Z" fill={color} />
    </svg>
  );
}
